<template>
    <div class="share" data-appear="a2">
        <div class="top">
            <svg width="15" height="17" viewBox="0 0 15 17">
                <g fill="none" fill-rule="evenodd" opacity=".699">
                    <g fill="#9C9C9C" fill-rule="nonzero">
                        <g>
                            <g>
                                <path
                                    d="M11.583 10.314c-.844 0-1.602.366-2.13.945l-3.35-2.083c.129-.326.2-.68.2-1.052s-.071-.725-.2-1.052l3.35-2.082c.529.579 1.287.945 2.13.945 1.592 0 2.887-1.295 2.887-2.887 0-1.593-1.295-2.888-2.887-2.888S8.696 1.456 8.696 3.047c0 .372.072.725.2 1.052l-3.35 2.083c-.528-.579-1.286-.945-2.13-.945C1.826 5.237.53 6.532.53 8.124s1.295 2.888 2.887 2.888c.845 0 1.602-.366 2.13-.945l3.35 2.082c-.129.327-.2.68-.2 1.052 0 1.592 1.294 2.888 2.886 2.888s2.887-1.296 2.887-2.888c0-1.592-1.295-2.887-2.887-2.887zm0-9.103c1.013 0 1.837.824 1.837 1.838 0 1.013-.824 1.837-1.837 1.837S9.746 4.062 9.746 3.05c0-1.014.824-1.838 1.837-1.838zM3.417 9.963c-1.013 0-1.837-.825-1.837-1.838 0-1.013.824-1.838 1.837-1.838s1.837.825 1.837 1.838c0 1.013-.824 1.838-1.837 1.838zm8.166 5.076c-1.013 0-1.837-.825-1.837-1.838 0-1.013.824-1.837 1.837-1.837s1.837.824 1.837 1.837-.824 1.838-1.837 1.838z"
                                    transform="translate(-278 -3045) translate(269 3045) translate(9)"/>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
        <ul>
            <li class="fb">
                <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentURL}`"
                   target="_blank">
                    <span class="icon-facebook"></span>
                </a>
            </li>
            <li class="twitter">
                <a :href="`https://twitter.com/intent/tweet?url=${currentURL}`"
                   target="_blank">
                    <span class="icon-twitter"></span>
                </a>
            </li>
            <li class="email">
                <a :href="`mailto:?subject=Festival du monde Arabe de Montréal&body=${currentURL}`">
                    <svg width="15" height="11" viewBox="0 0 15 11">
                        <g fill="none" fill-rule="evenodd">
                            <g stroke="#131313">
                                <g>
                                    <g>
                                        <g>
                                            <path d="M0 0H13.462V9.872H0z"
                                                  transform="translate(-279 -3204) translate(269 3045) translate(0 147) translate(10.77 12.564)"/>
                                            <path d="M0 0.436L6.731 5.821 13.462 0.436"
                                                  transform="translate(-279 -3204) translate(269 3045) translate(0 147) translate(10.77 12.564)"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </li>

            <li class="link">
                <a class="clipboard" @click="copyToClipboard(currentURL)">
                    <svg width="19" height="9" viewBox="0 0 19 9">
                        <g fill="none" fill-rule="evenodd" stroke-linecap="round">
                            <g stroke="#131313">
                                <g>
                                    <path
                                        d="M19.306 14h2.86c1.934 0 3.5 1.567 3.5 3.5S24.1 21 22.167 21h-2.834m-3.555 0h-2.944c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5h2.958m-2.914 3.553h9.235"
                                        transform="translate(-277 -3259) translate(269 3045) translate(0 201)"/>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </li>


            <template
                v-if="((content[0].event_date_start && content[0].event_date_end) && calendar === true) && isSafari() === false">
                <li class="agenda">
                    <a target="_blank"
                       :href="`http://www.google.com/calendar/event?action=TEMPLATE&dates=${isoDate(content[0].event_date_start.date)}%2F${isoDate(content[0].event_date_end.date)}&text=Festival%20du%20Monde%20Arabe&location=${encodeURI(content[0].event_where)}&details=${encodeURI(content[0].event_title)}`">

                        <svg width="15" height="15" viewBox="0 0 15 15">
                            <g fill="none" fill-rule="evenodd">
                                <g class="g" fill-rule="nonzero">
                                    <g>
                                        <g>
                                            <path
                                                d="M22.771 11.883h-1.167v-1.167h-.777v1.167h-6.222v-1.167h-.778v1.167H12.66c-1.073 0-1.945.872-1.945 1.945v8.944c0 1.072.872 1.945 1.945 1.945h10.11c1.072 0 1.945-.873 1.945-1.945v-8.945c0-1.072-.873-1.944-1.945-1.944zm1.166 10.888c0 .643-.523 1.166-1.166 1.166h-10.11c-.644 0-1.167-.523-1.167-1.166v-7h12.443v7zm0-7.777H11.494v-1.167c0-.644.523-1.167 1.167-1.167h1.167v.778h.777v-.777h6.222v.777h.777v-.777h1.167c.643 0 1.166.522 1.166 1.166v1.167z"
                                                transform="translate(-107 -1288) translate(72 1014) translate(25 264)"/>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </a>
                    <span class="info">{{$t('article.share.agenda')}}</span>
                </li>
            </template>

        </ul>
    </div>
</template>

<script>
    export default {
        name: "Share",
        props: {
            content: {
                type: Array,
                default: () => [],
            },
            calendar: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                currentURL: encodeURI(window.location.href),
            }
        },
        created() {
        },
        methods: {
            isSafari() {
                return this.$root.$browserDetect.isSafari;
            },
            isoDate(theDate) {
                theDate = theDate.replace(/-/g, '/').replace('T', ' ');
                let iso = new Date(theDate).toISOString();
                iso = iso.replace(/:/g, '');
                iso = iso.replace(/-/g, '');
                iso = iso.replace(/.000Z/g, 'Z');

                return iso;
            },
            copyToClipboard(slug) {
                const el = document.createElement('textarea');
                el.value = this.currentURL;
                el.setAttribute('readonly', '');
                el.style.position = 'absolute';
                el.style.left = '-9999px';
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            },
        }
    }
</script>

<style scoped>

</style>
